import React, { useState, useEffect } from 'react';
import { useT } from '../utils/i18n';

const StorageStatusCheck = () => {
  const t = useT();
  const [storageAvailable, setStorageAvailable] = useState(true);
  const [storageEstimate, setStorageEstimate] = useState(null);

  // Check storage availability
  useEffect(() => {
    const checkStorage = async () => {
      // Check if IndexedDB is available
      if (!window.indexedDB) {
        setStorageAvailable(false);
        return;
      }

      try {
        // Try to open a test database
        const testDB = indexedDB.open('test_storage_access');
        
        testDB.onerror = () => {
          console.error('IndexedDB access error - storage may be blocked or limited');
          setStorageAvailable(false);
        };
        
        testDB.onsuccess = () => {
          // Successfully opened database, now close it
          testDB.result.close();
          
          // Try to estimate storage usage if the API is available
          if (navigator.storage && navigator.storage.estimate) {
            navigator.storage.estimate().then(estimate => {
              setStorageEstimate({
                usage: estimate.usage,
                quota: estimate.quota,
                percentUsed: (estimate.usage / estimate.quota) * 100
              });
            });
          }
        };
      } catch (err) {
        console.error('Storage check error:', err);
        setStorageAvailable(false);
      }
    };

    checkStorage();
  }, []);

  // If storage is available, no need to show anything
  if (storageAvailable && (!storageEstimate || storageEstimate.percentUsed < 80)) {
    return null;
  }

  // Show warning if storage is almost full
  if (storageAvailable && storageEstimate && storageEstimate.percentUsed >= 80) {
    return (
      <div className="alert alert-warning">
        {t(
          'Storage space is getting low ({percent}% used). Some older cached recordings might be automatically deleted.',
          { percent: storageEstimate.percentUsed.toFixed(1) },
        )}
      </div>
    );
  }

  // Show error if storage is not available
  return (
    <div className="alert alert-danger">
      <strong>{t('Storage access is unavailable.')}</strong>{' '}
      {t("Your browser may have blocked storage access or you're in private/incognito mode. Offline recordings won't be saved for retry if uploads fail.")}
    </div>
  );
};

export default StorageStatusCheck;
